import apiClient, { unwrap } from './client'
import type { ClientApp } from './types'

export const clientsApi = {
  list() {
    return unwrap<ClientApp[]>(apiClient.get('/clients'))
  },

  create(data: { domain: string; name: string; description?: string; rate_limit?: number }) {
    return unwrap<{ id: number; domain: string; api_key: string; app_key: string; app_secret: string }>(apiClient.post('/clients', data))
  },

  review(id: number, action: 'approve' | 'reject') {
    return unwrap<unknown>(apiClient.put(`/clients/${id}/review`, { action }))
  },

  /** 启用 / 停用（取消接入） */
  setActive(id: number, active: boolean) {
    return unwrap<{ id: number; active: boolean }>(apiClient.put(`/clients/${id}/active`, { active }))
  },

  /** 从回收站恢复 */
  restore(id: number) {
    return unwrap<{ id: number; restored: boolean }>(apiClient.put(`/clients/${id}/restore`, {}))
  },

  delete(id: number) {
    return unwrap<{ deleted: boolean }>(apiClient.delete(`/clients/${id}`))
  },
}

export const recycleApi = {
  /** 回收站列表：聚合系统各类软删除数据 */
  list() {
    return unwrap<RecycleItem[]>(apiClient.get('/recycle-bin'))
  },
}

export interface RecycleItem {
  /** 类型：client（接入应用）/ template（邮件模板）/ backup（备份） */
  type: string
  typeLabel: string
  /** 主键：client/template 为数字，backup 为 UUID 字符串 */
  id: number | string
  name: string
  domain: string | null
  /** 引用信息（如 app_key / backup_type） */
  ref: string
  deletedAt: string
}
